import { useState, useEffect } from 'react';

/**
 * Returns true when the user has requested reduced motion
 * via the OS/browser `prefers-reduced-motion: reduce` media query.
 *
 * Use this hook to conditionally disable Framer Motion animations:
 *   const reduced = useReducedMotion();
 *   <motion.div animate={reduced ? {} : { y: 0 }} ... />
 */
export default function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handler = (e) => setReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return reduced;
}
